import axios from "axios";
import { ORDER_API, POS_API } from "constants/apiUrls";

// 주문 채널 거리별 할증 조회
export const getOrderDistCostApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/extra/distance`, {
    params: {shopId: shopId}
  });
  return response.data;
}

// 주문 채널 거리별 할증 수정
export const setOrderDistCostApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/extra/distance`, data);
}

// 주문 채널 무료 배달 리스트 조회
export const getOrderFreeDeliveryApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/delivery/free/ceo`, {
    params: {shopId: shopId},
    headers: { Authorization: `Bearer ceo` }
  });
  return response.data;
}

// 주문 채널 무료 배달 리스트 수정
export const setOrderFreeDeliveryApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/delivery/free`, data);
}

// 주문 채널 지역별 할증 조회
export const getOrderDongCostApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/extra/dong`, {
    params: {shopId: shopId}
  });
  return response.data;
}

// 주문 채널 지역별 할증 수정
export const setOrderDongCostApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/extra/dong`, data);
}

// 주문 채널 기상 할증 조회
export const getOrderWeatherCostApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/extra/weather/ceo`, {
    params: {shopId: shopId},
    headers: { Authorization: `Bearer ceo` }
  });
  return response.data;
}

// 주문 채널 기상 할증 수정
export const setOrderWeatherCostApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/extra/weather/ceo`, data, {
    headers: { Authorization: `Bearer ceo` }
  });
}

// 포스 채널 기상 할증 수정
export const setPosWeatherCostApi = async (data) => {
  await axios.put(`${POS_API}/shop/v2/extra/weather`, data);
}

// 주문 채널 기상 할증 조회
export const getOrderCostApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/delivery/order-cost`, {
    params: {shopId: shopId},
    headers: { Authorization: `Bearer ceo` }
  });
  return response.data;
}

export const setOrderCostApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/delivery/order-cost`, data);
};
